<template>
  <TheGreyWrapper>
    <TheHeader
      force-sm-style
      back-route="/"
    />
    <BaseSection class="mb-4">
      <BaseTitleGroup
        :title="$t('Forgot your password ?')"
        subtitle="Plateforme Kerala"
        class="mb-4"
      />
      <BaseWarningBox
        v-if="message"
        class="mb-4"
      >
        {{ message }}
      </BaseWarningBox>
      <form @submit.prevent="submit">
        <BaseInputGroup
          v-model="loginEmail"
          :label="$t('Email')"
          type="email"
          class="mb-4"
          autofocus
          required
        />
        <BaseButton
          :title="$t('Submit')"
          class="mb-6"
        />
      </form>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseInputGroup from '../components/BaseInputGroup.vue';
import BaseButton from '../components/BaseButton.vue';
import BaseWarningBox from '../components/BaseWarningBox.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { STORE_LOGIN_EMAIL } from '../store/mutation-types';
import { ASK_FOR_PASSWORD } from '../analytics';

export default {
  name: 'PasswordForgotten',
  metaInfo: {
    title: 'Mot de passe oublié',
  },
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseInputGroup,
    BaseButton,
    BaseWarningBox,
    TheGreyWrapper,
  },
  data() {
    return {
      message: null,
    };
  },
  computed: {
    loginEmail: {
      set(value) {
        this.$store.commit(`auth/${STORE_LOGIN_EMAIL}`, value);
      },
      get() {
        return this.$store.state.auth.loginEmail;
      },
    },
  },
  methods: {
    updateMessage() {
      this.message = 'Si vous disposez d\'un compte sur la plateforme, vous allez recevoir un email contenant des instructions de réinitialisation de votre mot de passe.';
    },
    submit() {
      analytics.track(ASK_FOR_PASSWORD);
      this.$store.dispatch('auth/submitPasswordForgotten').finally(this.updateMessage);
    },
  },
};
</script>
